module.exports = __webpack_public_path__ + "static/media/bg_btm.4e8afb63.jpg";